import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { Observable } from 'rxjs/Observable';

const CACHE_TIME: number = 5 * 60;

export class TimeServerPlugin extends SmartenitPlugin {
  get stateTTL(): number {
    return CACHE_TIME;
  }

  public getStatus(
    context?: string,
    force?: boolean,
    subscribe?: boolean,
    payload?: any,
    sendDirect: boolean = false
  ): void {
    super.getStatus(context, force, subscribe, payload, true);
  }

  public getStatusPayload(): any {
    return ['Time', 'UserTime', 'UserTimezoneCode', 'UserSunsetTime', 'UserSunriseTime'];
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    this.state = {};
    const attribute = message && message.attributeOrMethod;
    const response = message && message.data && message.data.response;
    const value = response && response.value;

    if (attribute) {
      this.state[attribute] = response.value;
    }
    this._onUpdate.next({ state: this.state });
    return this.state;
  }
}
